import React from "react";
import { useParams, useHistory } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { ROADMAP_QUERY } from "pages/Round/roadmapQuery";
import useAuth from "utils/useAuth";
import { utcNow } from "utils/date";
import Loading from "components/Loading";

/**
 * AutoLogin Component
 *
 * Handles automatic authentication via QR code scanning.
 * Validates the roadmap code and logs the user in automatically.
 */
const AutoLogin = () => {
  const { code } = useParams();
  const history = useHistory();
  const { login } = useAuth();

  const { loading, error, data } = useQuery(ROADMAP_QUERY, {
    variables: { code },
    skip: !code,
    onCompleted: (response) => {
      const roadmap = response?.roadmap;

      if (roadmap?.__typename === "Roadmap") {
        // Automatically log in the user
        login({
          code,
          officeName: roadmap.office.name,
          crewmates: roadmap.crewmates,
          truck_name: roadmap.truck_name,
          login_at: utcNow(),
        });

        // Redirect to the main roadmap view
        history.push("/");
      }
    },
    onError: (error) => {
      console.error("Auto-login error:", error);
      // Redirect to home page on error
      setTimeout(() => {
        history.push("/");
      }, 3000);
    },
  });

  if (!code) {
    return (
      <div
        className="container"
        style={{ marginTop: "8rem", textAlign: "center" }}
      >
        <h2>Code invalide</h2>
        <p>Le code d&apos;authentification est manquant.</p>
        <button
          className="button-primary"
          onClick={() => history.push("/")}
          style={{ marginTop: "2rem" }}
        >
          Retour à l&apos;accueil
        </button>
      </div>
    );
  }

  if (loading) {
    return <Loading />;
  }

  if (error || data?.roadmap?.__typename !== "Roadmap") {
    return (
      <div
        className="container"
        style={{ marginTop: "8rem", textAlign: "center" }}
      >
        <h2>Erreur d&apos;authentification</h2>
        <p>
          Le code scanné n&apos;est pas valide ou la tournée n&apos;existe pas.
          <br />
          Redirection vers la page d&apos;accueil...
        </p>
        <button
          className="button-primary"
          onClick={() => history.push("/")}
          style={{ marginTop: "2rem" }}
        >
          Retour à l&apos;accueil
        </button>
      </div>
    );
  }

  // This should not be reached as onCompleted redirects
  return <Loading />;
};

export default AutoLogin;
